module.exports = __webpack_public_path__ + "img/index-login.271073f6.png";